import {createApp} from 'vue'
import App from './App.vue'
import {createPinia} from "pinia";
import router from './core/router/router';

require('@popperjs/core/dist/umd/popper.js');
require('bootstrap');

const pinia = createPinia();

createApp(App)
    .use(router)
    .use(pinia)
    .mount('#app')
